"use client";

import * as React from "react";

export function useTransientScrollState(timeoutMs = 720) {
  const [isScrolling, setIsScrolling] = React.useState(false);
  const timeoutRef = React.useRef<number | null>(null);

  const handleScroll = React.useCallback(() => {
    setIsScrolling(true);

    if (timeoutRef.current !== null) {
      window.clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      setIsScrolling(false);
      timeoutRef.current = null;
    }, timeoutMs);
  }, [timeoutMs]);

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { isScrolling, handleScroll };
}
